import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { CountryRulesV2, ICountryMask, IResponseModel } from '@core/interface';
import { API, environment } from '@core/envs';
import { MasksService } from '../masks/masks.service';
import { RulesService } from '../rules-service/rules.service';

@Injectable({
  providedIn: 'root'
})
export class CountryRulesLibService {
  readonly #http = inject(HttpClient);
  readonly #masksService = inject(MasksService);
  readonly #rulesService = inject(RulesService);

  loadMasks(country: string): Observable<IResponseModel<ICountryMask>> {
    const api = environment.getRoute(API.backoffice, true);
    const endpoint = `${api}/internationalization/v1/masks/${country}`;
    this.#masksService.isDisabledCityCode.set(this.#masksService.isDisabledCityCodeByCountry(country));

    return this.#http.get<IResponseModel<ICountryMask>>(endpoint).pipe(
      map((data) => {
        const { useMaskCityCodeToPhone } = data.response;
        const masks = this.#masksService.formatMask(data.response);
        this.#masksService.masksSignal.set(masks);
        this.#masksService.active.set(true);
        this.#masksService.disabledAllFieldsPhone.set(useMaskCityCodeToPhone === 'true');

        sessionStorage.setItem('masks', JSON.stringify(masks));

        return data;
      })
    );
  }

  loadRules(country: string): Observable<IResponseModel<CountryRulesV2>> {
    const api = environment.getRoute(API.transformation);
    const endpoint = `${api}/countries/${country}/rules`;
    return this.#http.get<IResponseModel<CountryRulesV2>>(endpoint).pipe(
      tap((data) => {
        this.#rulesService.setRules(data.response);
      })
    );
  }
}
